import { Practice, PracticeAttendee } from '../types/practice'
import { mockData } from '../services/mockData'
import { syncAttendees, workerToAttendee } from '../utils/practices'

// Sample attendees taken from the company's Risorse umane, so they match
// the check-list shown in the "Partecipanti al corso" window
function companyAttendees(companyName: string, count: number): PracticeAttendee[] {
  const company = mockData.getClientByName(companyName)
  if (!company) return []
  return mockData
    .getWorkersByClient(company.id)
    .slice(0, count)
    .map(workerToAttendee)
}

export const practices: Practice[] = [
  {
    id: 'prt-008',
    clientType: 'anagrafica',
    companyName: 'Azienda 6 SRL',
    clientEmail: 'amministrazione@azienda6.it',
    attendees: companyAttendees('Azienda 6 SRL', 4),
    category: 'Sicurezza sul lavoro',
    productCode: 'FOR-AI2',
    requestedCourseCode: 'AI2-I2-01',
    rateType: 'singola',
    singleFee: 100,
    participantsCount: 4,
    source: 'CNA Toscana',
    date: '2026-09-18',
    status: 'Positivo',
    history: [],
    deliveryMode: 'multiaziendale',
    courseStartDate: '2026-10-12',
    courseEndDate: '2026-10-12',
    courseCode: 'AI2-I2-01',
    courseDetails: 'Prova pratica con estintori nel piazzale.',
    participants: [],
    schedulingConfirmed: true,
    courseStatus: 'Programmato',
    proforma: 'off',
    invoice: 'off',
    certificates: 'Da inviare',
  },
  {
    id: 'prt-001',
    clientType: 'anagrafica',
    companyName: 'Azienda 0 SRL',
    clientEmail: 'hr@azienda0.it',
    attendees: companyAttendees('Azienda 0 SRL', 5),
    category: 'Sicurezza sul lavoro',
    productCode: 'FOR-PRE',
    requestedCourseCode: 'PRE-A0-01',
    rateType: 'oraria',
    hourlyRate: 60,
    courseHours: 16,
    participantsCount: 5,
    source: 'Confartigianato Arezzo',
    date: '2026-09-02',
    status: 'Positivo',
    history: [
      { id: 'h-1', kind: 'telefono', notes: 'Prima richiesta del referente HR, 5 preposti.', createdAt: '2026-09-01T09:12:00' },
      { id: 'h-2', kind: 'email', notes: 'Inviata proposta economica.', createdAt: '2026-09-02T15:40:00' },
    ],
    deliveryMode: 'aziendale',
    courseStartDate: '2026-10-05',
    courseEndDate: '2026-10-06',
    courseCode: 'PRE-A0-01',
    courseDetails: 'Presso sede legale, 9:00–13:00 / 14:00–18:00',
    participants: [],
    schedulingConfirmed: true,
    courseStatus: 'Programmato',
    proforma: 'fatto',
    invoice: 'da_fare',
    certificates: 'Da inviare',
  },
  {
    id: 'prt-002',
    clientType: 'anagrafica',
    companyName: 'Impresa 2 SPA',
    clientEmail: 'sicurezza@impresa2.it',
    attendees: companyAttendees('Impresa 2 SPA', 3),
    category: 'Sicurezza sul lavoro',
    productCode: 'FOR-AI2',
    requestedCourseCode: 'AI2-I2-01',
    rateType: 'oraria',
    hourlyRate: 150,
    courseHours: 8,
    participantsCount: 3,
    source: 'CNA Toscana',
    date: '2026-09-10',
    status: 'Positivo',
    history: [
      { id: 'h-3', kind: 'incontro', notes: 'Sopralluogo e definizione date.', createdAt: '2026-09-09T11:00:00' },
    ],
    deliveryMode: 'multiaziendale',
    courseStartDate: '2026-10-12',
    courseEndDate: '2026-10-12',
    courseCode: 'AI2-I2-01',
    courseDetails: 'Prova pratica con estintori nel piazzale.',
    participants: [],
    schedulingConfirmed: true,
    courseStatus: 'Programmato',
    proforma: 'off',
    invoice: 'da_fare',
    certificates: 'Da inviare',
  },
  {
    id: 'prt-003',
    clientType: 'individuo',
    firstName: 'Giulia',
    lastName: 'Marchetti',
    clientEmail: 'giulia.marchetti@email.it',
    category: 'HACCP e sicurezza alimentare',
    productCode: 'FOR-HAC',
    requestedCourseCode: 'HAC-OD',
    rateType: 'singola',
    singleFee: 60,
    participantsCount: 1,
    date: '2026-09-15',
    status: 'Positivo',
    history: [
      { id: 'h-4', kind: 'messaggio', notes: 'Richiesta via WhatsApp.', createdAt: '2026-09-15T18:22:00' },
    ],
    deliveryMode: 'elearning',
    courseCode: 'HAC-OD',
    participants: [
      { id: 'p-1', firstName: 'Giulia', lastName: 'Marchetti', email: 'giulia.marchetti@email.it', username: 'g.marchetti', credentialsSentAt: '2026-09-16T10:05:00' },
    ],
    schedulingConfirmed: true,
    courseStatus: 'On-demand',
    proforma: 'off',
    invoice: 'fatto',
    certificates: 'Inviati',
  },
  {
    id: 'prt-004',
    clientType: 'anagrafica',
    companyName: 'Impresa 5 SPA',
    // 5 people from the registry + 3 anonymous participants to complete
    attendees: syncAttendees(companyAttendees('Impresa 5 SPA', 5), 8),
    category: 'Sicurezza sul lavoro',
    productCode: 'FOR-FGL',
    requestedCourseCode: 'FGL-2026-11',
    rateType: 'singola',
    singleFee: 80,
    participantsCount: 8,
    source: 'Partner Sicurezza Srl',
    date: '2026-09-20',
    status: 'In valutazione',
    history: [
      { id: 'h-5', kind: 'email', notes: 'Inviato preventivo, in attesa di risposta.', createdAt: '2026-09-20T10:30:00' },
      { id: 'h-6', kind: 'sollecito', notes: 'Sollecito telefonico al titolare.', createdAt: '2026-09-27T09:15:00' },
    ],
    participants: [],
    schedulingConfirmed: false,
    proforma: 'off',
    invoice: 'off',
    certificates: 'Da inviare',
  },
  {
    id: 'prt-005',
    clientType: 'occasionale',
    businessName: 'Bar Centrale di Neri Luca',
    clientEmail: 'barcentrale@email.it',
    // Occasional company: people entered on the spot, kept only in the practice
    // 4 participants declared: 3 entered, 1 record still to fill in
    attendees: syncAttendees(
      [
        { id: 'att-o1', firstName: 'Luca', lastName: 'Neri', email: 'luca.neri@email.it' },
        { id: 'att-o2', firstName: 'Marta', lastName: 'Fabbri', email: 'marta.fabbri@email.it' },
        { id: 'att-o3', firstName: 'Davide', lastName: 'Sarti', email: 'davide.sarti@email.it' },
      ],
      4,
    ),
    category: 'HACCP e sicurezza alimentare',
    productCode: 'FOR-HAC',
    requestedCourseCode: 'HAC-OD',
    rateType: 'singola',
    singleFee: 60,
    participantsCount: 4,
    date: '2026-09-22',
    status: 'In valutazione',
    history: [],
    participants: [],
    schedulingConfirmed: false,
    proforma: 'off',
    invoice: 'off',
    certificates: 'Da inviare',
  },
  {
    id: 'prt-006',
    clientType: 'anagrafica',
    companyName: 'Studio 1 Associati',
    attendees: companyAttendees('Studio 1 Associati', 4),
    category: 'Sicurezza sul lavoro',
    productCode: 'FOR-CAR',
    requestedCourseCode: 'CAR-S1-01',
    rateType: 'oraria',
    hourlyRate: 125,
    courseHours: 12,
    participantsCount: 4,
    source: 'Studio Commercialisti Rossi & Associati',
    date: '2026-08-28',
    status: 'Negativo',
    rejectionDate: '2026-09-05',
    rejectionReason: 'Il cliente ha scelto un altro ente formatore per motivi di prezzo.',
    history: [
      { id: 'h-7', kind: 'telefono', notes: 'Il cliente comunica la rinuncia.', createdAt: '2026-09-05T12:10:00' },
    ],
    participants: [],
    schedulingConfirmed: false,
    proforma: 'off',
    invoice: 'off',
    certificates: 'Da inviare',
  },
  {
    id: 'prt-007',
    clientType: 'anagrafica',
    companyName: 'Azienda 3 SRL',
    attendees: companyAttendees('Azienda 3 SRL', 2),
    category: 'Sicurezza sul lavoro',
    productCode: 'FOR-ARL',
    requestedCourseCode: 'ARL-2025-06',
    rateType: 'singola',
    singleFee: 120,
    participantsCount: 2,
    date: '2025-06-01',
    status: 'Positivo',
    history: [],
    deliveryMode: 'aziendale',
    courseStartDate: '2025-06-10',
    courseEndDate: '2025-06-10',
    courseCode: 'ARL-2025-06',
    participants: [],
    schedulingConfirmed: true,
    courseStatus: 'Eseguito',
    proforma: 'fatto',
    invoice: 'fatto',
    // Fattura pagata + attestati da inviare: row highlighted in the listing
    certificates: 'Da inviare',
  },
]
